// react
import { useContext } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// types
import { Project } from '../../../@types';

// context
import { ContextActivities } from '../../pages/Project/Project.context';

// router
import { Link as RouterLink } from 'react-router-dom';

// mui
import { Button, Grid, Typography } from '@mui/material';

// ui
import { CardLineItems } from '../../cards/CardLineItems/CardLineItems';
import { LineItemProps } from '../LineItem/LineItem';

// icons
import {
	ArrowForwardOutlined as IconArrowForward,
	TimerOutlined as IconTimer,
} from '@mui/icons-material';

// utils
import { constructActivityItems } from '../../../utils/activities';

// props
export interface ActivityProps {
	project: Project;
}

export const Activity = ({ project }: ActivityProps) => {
	// hooks
	const { t } = useTranslation();

	// context
	const { activities, isLoadingActivities } = useContext(ContextActivities);

	// items
	const activityItems: LineItemProps[] = constructActivityItems({ activities, t });

	return (
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<Grid alignItems="flex-end" container justifyContent="space-between" spacing={2}>
					<Grid item>
						<Typography variant="h2">{t('activity.title')}</Typography>
					</Grid>
					<Grid item>
						<Button
							component={RouterLink}
							endIcon={<IconArrowForward />}
							size="small"
							sx={{ padding: 0 }}
							to={`/project/${project.idWbg}/activities`}
							variant="text">
							{t('seeAllActivities')}
						</Button>
					</Grid>
				</Grid>
			</Grid>
			<Grid item xs={12}>
				<CardLineItems
					empty={{
						content: { children: t('empty.activity.content') },
						IconCircleProps: { icon: <IconTimer /> },
						title: { children: t('empty.activity.title') },
					}}
					isLoading={isLoadingActivities}
					items={activityItems}
				/>
			</Grid>
		</Grid>
	);
};
